'use strict'
module.exports = (typeof self === 'object' && self.self === self && self) ||
  (typeof global === 'object' && global.global === global && global) ||
  this



//////////////////
// WEBPACK FOOTER
// ./~/_window-or-global@1.0.1@window-or-global/lib/index.js
// module id = 1495
// module chunks = 0